'use client';

import React from 'react';

import { FeatureCard } from './FeatureCard';
import { cn } from '@/utilities/cn';
import { FeaturesBlock } from '@payload-types';

export const Grid: React.FC<FeaturesBlock> = ({
  features,
  numberAsIcon,
  columnCount,
  featuresBackgroundColor,
}) => {
  return (
    <div
      className={cn(
        'grid gap-5 md:grid-cols-1 md:gap-2',
        columnCount === '2' && 'grid-cols-2',
        columnCount === '3' && 'grid-cols-3',
        columnCount === '4' && 'grid-cols-4',
      )}
    >
      {features?.map((feature, idx, arr) => (
        <FeatureCard
          numberAsIcon={numberAsIcon}
          featuresBackgroundColor={featuresBackgroundColor}
          index={idx}
          data={feature}
          key={feature.id}
        />
      ))}
    </div>
  );
};
